export const pickComponentsFromIndex = (
  componentsIndex: Record<string, unknown>,
  {
    componentList,
    reactComponentParameters,
  }: { componentList: string[] | undefined; reactComponentParameters: Record<string, Record<string, boolean>> }
) => {
  const selectedList = pickComponentsListFromIndex(componentsIndex, componentList);
  const selectedReactComponents = pickReactComponentParametersFromIndex(componentsIndex, reactComponentParameters);

  return { ...selectedList, ...selectedReactComponents };
};

const pickComponentsListFromIndex = (componentsIndex: Record<string, unknown>, componentList: string[] | undefined) => {
  if (componentList === undefined) return {};

  return componentList.reduce((acc, componentName: string) => {
    if (!(componentName in componentsIndex)) return acc;

    return {
      ...acc,
      [componentName]: componentsIndex[componentName],
    };
  }, {});
};

const pickReactComponentParametersFromIndex = (
  componentsIndex: Record<string, unknown>,
  reactComponentParameters: Record<string, Record<string, boolean>>
) => {
  return Object.keys(reactComponentParameters).reduce((acc, componentName) => {
    if (!(componentName in componentsIndex)) return acc;

    if (reactComponentParameters[componentName].isReactComponent) {
      return {
        ...acc,
        [componentName]: componentsIndex[componentName],
      };
    }
    return acc;
  }, {});
};

export default pickComponentsFromIndex;
